import React, { useEffect, useImperativeHandle, useState, useRef } from 'react';
import { Cartesian2 } from 'cesium';
import SceneTransforms from 'cesium/Source/Scene/SceneTransforms';
import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';

export default function (props) {
    const [position, setPosition] = useState({});
    const closeHandler = useRef();

    useEffect(() => {
        if (props._position) {
            // 先销毁已注册的事件
            if (closeHandler.current) {
                closeHandler.current.call();
                closeHandler.current = null;
            }
            let c = new Cartesian2(props.position.x, props.position.y);
            setPosition(c);
            closeHandler.current = props.map.scene.postRender.addEventListener(function () {
                let changedC = (SceneTransforms.wgs84ToWindowCoordinates
                    ? SceneTransforms.wgs84ToWindowCoordinates
                    : SceneTransforms.worldToWindowCoordinates)(
                    props.map.scene,
                    props._position,
                );
                if (c && changedC && c.x && changedC.x && c.y && changedC.y) {
                    if (c.x !== changedC.x || c.y !== changedC.y) {
                        c = changedC;
                        setPosition(changedC);
                    }
                }
            });
        }
    }, [props._position]);

    useImperativeHandle(props.infoWindowRef, () => {
        return {
            destory: close
        }
    })

    const close = () => {
        closeHandler.current && closeHandler.current.call();
        props.onClose && props.onClose();
    };

    const style = {
        top: `${position.y || 0}px`,
        left: `${position.x || 0}px`,
        marginTop: `${props.offset?.y || 0}px`,
        marginLeft: `${props.offset?.x || 0}px`,
    };
    return (
        <div className={classNames('cesium-popup')} style={style}>
            <CloseOutlined onClick={close} className={classNames('cesium-close')} />
            {props.children}
        </div>
    );
}
